/**
 * Build a t.me link to open a message in Telegram (supergroups/channels).
 * Returns null when the chat id format is not linkable.
 */
export function telegramMessageUrl(platformChatId, platformMessageId) {
  const chatRaw = String(platformChatId ?? '').trim();
  const msgId = String(platformMessageId ?? '').trim();
  if (!chatRaw || !msgId || !/^\d+$/.test(msgId)) {
    return null;
  }

  let internalChatId = null;
  if (chatRaw.startsWith('-100') && chatRaw.length > 4) {
    internalChatId = chatRaw.slice(4);
  } else if (chatRaw.startsWith('-')) {
    return null;
  }

  if (!internalChatId || !/^\d+$/.test(internalChatId)) {
    return null;
  }

  return `https://t.me/c/${internalChatId}/${msgId}`;
}
